import { Link } from 'react-router-dom';
import { RoutePaths } from 'routes/route-paths';

function LoanAgreement() {
  return (
    <div>
      <h1 className="mb-2 font-bold text-center">
        ESSENTIAL SERVICES LOAN AGREEMENT
      </h1>
      <p className="font-bold">
        THIS ESSENTIAL SERVICES LOAN AGREEMENT{' '}
        <span className="font-normal">is made this day between </span>
        <span className="font-bold"> You (the “Borrower”)</span>{' '}
        <span className="font-normal">and </span>
        <span className="font-bold"> JOMPSTART DIGITAL LIMITED, </span>
        <span className="font-normal">
          a limited liability company of 50, Tapa Street, Ebute Metta, Lagos
          State (the <span className="font-bold">“Creditor”</span> or
          <span className="font-bold">“JompStart”</span>).
        </span>
      </p>

      <p className="mt-5">
        <span className="font-bold">“Borrower”</span>,{' '}
        <span className="font-bold">"You"</span>,{' '}
        <span className="font-bold">“Your”</span>
        and their equivalents in this Agreement shall refer to you as the
        customer requesting an essential services loan from JompStart. Where the
        context admits, they shall include your representatives, agents, heirs,
        and successors-in-title).
      </p>

      <h2 className="font-bold">WHEREAS</h2>
      <ul>
        <li className="mb-3">
          <strong>a.</strong> JompStart is a service aggregation platform /
          marketplace that makes it easy to find and conveniently pay for life’s
          essential services. As a part of its core features (and through
          strategic partnerships with financial institutions and fund managers),
          JompStart offers a digital lending (Get Now, Pay Later) and savings
          platform/product (Save with Jomp) for its customers to borrow and/or
          save money toward the payment for essential services.
        </li>
        <li className="mb-3">
          <strong>b.</strong>You have made a request of the amount as inputted
          by you in the application process to JompStart to provide a loan for
          you to pay for an essential service.
        </li>
        <li className="mb-3">
          <strong>c.</strong> You and JompStart have made this Agreement to set
          out the terms and conditions of the loan and your obligations.
        </li>
      </ul>

      <h2 className="font-bold">
        1. TERMS OF THE ESSENTIAL SERVICES LOAN (ESL)
      </h2>
      <ol>
        <li className="mb-3">
          <strong>1.1.</strong> JompStart has agreed to offer the total sum as
          shown to you in the previous pages.
        </li>
        <li className="mb-3">
          <strong>1.2.</strong> The ESL shall be subject to a{' '}
          <strong>
            {' '}
            one-off processing fee of two percent (2%) and a reducing balance
            monthly interest of six percent (6%).
          </strong>
        </li>
        <li className="mb-3">
          <strong>1.3.</strong> The tenor of the ESL is the number of months
          shown to you or selected by you, beginning from the date of
          disbursement of the loan to you.
        </li>
        <li>
          <strong>1.4.</strong> The Borrower agrees that the ESL shall be paid
          directly to the provider of the essential service you are requesting
          the loan for, except as decided otherwise by JompStart with your
          concurrence.
        </li>
      </ol>

      <h2 className="font-bold">2. LOAN OBLIGATIONS</h2>
      <ol>
        <li className="mb-3">
          <strong>2.1.</strong>The Borrower agrees and is obliged to repay the
          loan based on the monthly repayment schedule contained in the
          application process and in your loan repayment tab in your JompStart
          profile account.
        </li>
        <li className="mb-3">
          <strong>2.2.</strong>The Borrower shall provide information such as
          Bank Verification Number (BVN), National Identification Number (NIN),
          Bank Account statements, guarantors and collateral (where required),
          and other relevant information deemed important and necessary by
          JompStart for the assessment of the Borrower’s ability to repay the
          requested ESL and for the actual repayment of the ESL.
        </li>
        <li className="mb-3">
          <strong>2.3.</strong> You agree and consent that JompStart may share
          your relevant personal data with partners including but not limited to
          credit bureaus and banking partners for the credit assessment of the
          Borrower and other purposes connected with this Agreement, including
          repayment.
        </li>
        <li className="mb-3">
          <strong>2.4.</strong> The Borrower agrees that the Creditor has the
          right to use every legal means, including but not limited to an action
          in law, subject to the provision on dispute resolution below, to
          recover the loan amount with accruing interests, penalties, and
          damages if the Borrower defaults in the repayment as and when due.
        </li>
        <li className="mb-3">
          <strong>2.5.</strong> The Borrower also agrees and consents that,
          notwithstanding any other provision of this Agreement, JompStart and /
          or its banking partner(s) may approach other financial institutions to
          settle the Borrower’s obligations to JompStart from the bank
          account(s) of the Borrower held with such financial institutions.
        </li>
        <li className="mb-3">
          <strong>2.6.</strong> The Borrower agrees and is obliged to indemnify
          and keep indemnified the Creditor and its banking partner(s) against
          any cost and expenses suffered and incurred by the Creditor and its
          banking partner(s) (including but not limited to legal fees) arising
          out of the failure of the Borrower to perform the obligations in this
          Agreement.
        </li>
        <li className="mb-3">
          <strong>2.7.</strong> The Borrower agrees that{' '}
          <strong>
            {' '}
            a late payment penalty of 0.5% flat per day shall apply to any
            unpaid part of the loan after each due date,{' '}
          </strong>{' '}
          in addition to the interest rate.
        </li>
        <li className="mb-3">
          <strong>2.8.</strong> The Parties agree that failure of the Borrower’s
          service provider or the quality, or otherwise, of the service of the
          service provider shall not affect the repayment obligation of the
          Borrower to the Creditor.
        </li>
      </ol>

      <h2 className="font-bold">3. ASSIGNMENT</h2>
      <ol>
        <li className="mb-3">
          <strong>3.1.</strong> The Borrower shall not assign its obligations
          under this Agreement to any third party without the prior written
          consent of the Creditor.
        </li>
        <li className="mb-3">
          <strong>3.2.</strong> The Creditor shall be entitled to assign or
          transfer the benefit of this Agreement at any time before the full and
          final repayment to any party without the consent of the Borrower being
          required, and any such assignment or transfer shall not release the
          Borrower from the Borrower’s liability under this Agreement.
        </li>
      </ol>

      <h2 className="font-bold">4. SEVERANCE</h2>
      <p className="mb-3">
        If any provision of this Agreement is held invalid, illegal, or
        unenforceable for any reason by any court of competent jurisdiction,
        such provision shall be severed and the remainder of the provisions
        hereof shall continue in full force and effect as if this Agreement had
        been executed without the invalid, illegal, or unenforceable provision,
        and such invalid, illegal, or unenforceable provision shall not by any
        means affect the full repayment obligation of the Borrower under this
        Agreement.
      </p>

      <h2 className="font-bold">5. MISCELLANEOUS</h2>
      <ol>
        <li className="mb-3">
          <strong>5.1.</strong> You confirm that you have read and understood
          the Terms and Conditions of JompStart at{' '}
          <Link to={RoutePaths.USER_TERMS} className="text-blue-400">
            Terms and Conditions{' '}
          </Link>
          which are also applicable to the loan obligation.
        </li>
        <li className="mb-3">
          <strong>5.2.</strong> JompStart states that the ESL is provided by
          JompStart as a licensed money lender and / or in conjunction with its
          Banking Partner(s).
        </li>
        <li className="mb-3">
          <strong>5.3.</strong>JompStart and the Borrower agree that either
          JompStart or its Banking Partner(s), or both of them acting together,
          shall have the right to seek legal redress against the Borrower for
          the repayment of the ESL.
        </li>
        <li className="mb-3">
          <strong>5.4.</strong> This Agreement shall terminate upon the full and
          final repayment of the loan by the Borrower and no further obligation
          shall subsist thereafter.
        </li>
        <li className="mb-3">
          <strong>5.5.</strong> Any dispute arising from this Agreement shall be
          resolved amicably between the Parties, but where such attempt at
          amicable resolution is not successful after fourteen (14) days of the
          notice of the dispute, such dispute shall be referred to a sole
          mediator in accordance with the rules and procedures of the Lagos
          Multi-Door Courthouse (LMDC) and shall be resolved within fifteen (15)
          days.
        </li>
        <li className="mb-3">
          <strong>5.6.</strong> Where the dispute borders on the failure of the
          Borrower to repay the loan or any part of it, the Borrower shall bear
          the total cost of the mediation and other dispute resolution processes
          involved.
        </li>
        <li className="mb-3">
          <strong>5.7.</strong>Where the Borrower refuses or neglects to
          participate in the mediation proceedings, or the outcome of the
          mediation does not include the repayment of the ESL with interest, or
          where the Borrower does not repay the ESL within thirty (30) days of
          the conclusion of mediation or the period agreed under mediation,
          JompStart shall have a right to proceed to a court of competent
          jurisdiction to either enforce the resolution under mediation or
          commence a fresh action against the Borrower for the repayment of the
          ESL.
        </li>
      </ol>
      <div className="font-bold">
        <h3>ACCEPTANCE:</h3>
        <h3>
          BY TICKING THE BOX BELOW, I ACCEPT AND AGREE TO THE TERMS CONTAINED IN
          THIS LOAN AGREEMENT WITH JOMPSTART.
        </h3>
      </div>
    </div>
  );
}

export default LoanAgreement;
